var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.476 11.867c.63 0 1.144.508 1.144 1.133v12.367a1.14 1.14 0 01-1.144 1.133H2.423a1.14 1.14 0 01-1.144-1.133V13a1.14 1.14 0 011.144-1.133h16.053zm-13.63-5.05c0-3.06 2.514-5.55 5.604-5.55 3.09 0 5.603 2.49 5.603 5.55V10.6H4.846V6.817zM10.45 0C6.655 0 3.567 3.058 3.567 6.817V10.6H2.423C1.087 10.6 0 11.676 0 13v12.367c0 1.323 1.087 2.4 2.423 2.4h16.053c1.336 0 2.423-1.077 2.423-2.4V13c0-1.324-1.087-2.4-2.423-2.4h-1.144V6.817C17.332 3.058 14.244 0 10.45 0z",
    fill: "#8B9196"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.478 16.23c-.915 0-1.66.738-1.66 1.643 0 .56.285 1.077.762 1.382l.184.117v2.642c0 .388.32.704.711.704.392 0 .711-.316.711-.704v-2.64l.186-.118c.478-.304.764-.82.764-1.383 0-.905-.744-1.642-1.658-1.642",
    fill: "#A4A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon_password.f95b1c67b2026e192b7b32c0336e2b05.svg";
export { ForwardRef as ReactComponent };